<template>
  <div 
    v-if="similarProducts.length"
    class="product-same-category">
    <div class="site-paddings">
      <div class="title--section__title-area">
        <h3>Nella stessa categoria</h3>
      </div>
    </div>
    <SwiperTab :list="similarProducts" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SwiperTab from '@/components/SwiperTab/SwiperTab.vue'

export default {
  name: 'ProductSameCategory',
  components: {
    SwiperTab
  },
  data: () => ({
    loading: true
  }),
  props: {
    slug: {
      type: String,
      required: true
    },
    shownProducts: {
      type: Number,
      default: () => 8
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'products',
      'product',
      'nodes'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    },
    currentNode: {
      get () {
        if (this.loading) return undefined
        return this.nodes.find(node => {
          if (typeof node.fields.products === 'undefined') return false
          return node.fields.products.find(product => {
            return product.sys.id === this.currentProduct.sys.id
          }) !== undefined
        })
      }
    },
    similarProducts: {
      get () {
        if (this.loading) return []
        if (this.currentNode === 'undefined') return []
        return this.currentNode.fields.products
          .filter(productElement => this.currentProduct.fields.slug !== productElement.fields.slug)
          .slice(0, this.shownProducts - 1)
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts',
      'loadNodes'
    ]),
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadProducts(), this.loadNodes()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import './../../assets/scss/breakpoint.scss';
  @import './../../assets/scss/typo.scss';
  
  .product-same-category{
    padding-top: 3rem;
  }

  .site-paddings{
    @include site-paddings;
  }

  .title--section__title-area{
    border-top: 1px solid #E6E6E6;
    margin: 4rem 0;
    h3{
      position: absolute;
      left: 50%; top: 0;
      transform: translate3d(-50%, -50%, 0);
      text-transform: uppercase;
      letter-spacing: 2px;
      margin: 0;
      background-color: #f2fbfb;
      color: #484848;
      padding: 5px 15px;
      font-size: .9rem;
      width: 280px;
      text-align: center;
      @include media(">=large"){
        font-size: 1.0625rem;
        padding: 5px 35px;
        width: 340px;
      }
    }
  }
</style>

